import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Flex } from '@balance-web/flex';

import {
  DownloadMateMobile,
  DownloadMateWeb,
} from '../../components/mate-invitation';

export const Route = createFileRoute('/m/mate')({
  component: MateDeeplinkDownloadRoute,
});

function MateDeeplinkDownloadRoute() {
  return (
    <Flex alignItems="center" direction="column" minHeight="100vh" width="100%">
      <DownloadMateWeb />
      <DownloadMateMobile />
    </Flex>
  );
}
